import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import type { UserRole } from '../../types/index';

interface Props {
  /** Roles that are permitted to access the nested routes (prms-based, for Master Admin routes). */
  allowedRoles?: UserRole[];
}

/**
 * Layout route (renders <Outlet />) that enforces prms-based role access.
 * Every authenticated user gets full access to AI tools/files/pricing —
 * only the Master Admin section is role-gated.
 */
export function ProtectedRoute({ allowedRoles }: Props) {
  const { isAuthenticated, user } = useAuthStore();

  if (!isAuthenticated || !user) {
    return <Navigate to="/login" replace />;
  }

  const isSuperAdmin = (user.prms ?? []).includes('*');

  if (allowedRoles && allowedRoles.length > 0) {
    if (!isSuperAdmin && !allowedRoles.includes(user.role)) {
      return <Navigate to="/403" replace />;
    }
  }

  return <Outlet />;
}
